import { Component } from "@angular/core";
import { pwaInstaller } from "../../../../pwa";
import { AsyncPipe } from "@angular/common";
import { ButtonComponent } from "../button/button.component";
import { MatRipple } from "@angular/material/core";

@Component({
    selector: 'pwa-installer',
    templateUrl: './pwa-installer.component.html',
    styleUrls: ['./pwa-installer.component.scss'],
    standalone: true,
    imports: [MatRipple, ButtonComponent, AsyncPipe]
})
export class PwaInstallerComponent {
    pwaInstaller = pwaInstaller;
}